import Attribute from './Attribute'

export default class InstancedAttribute extends Attribute {
  constructor(array, itemSize, divisor = 1) {
    super(array, itemSize);
    this.divisor = divisor;
    this.dynamic = false;
  }

  clone() {
    return new InstancedAttribute(this.array, this.itemSize, this.divisor);
  }
}
